import { SearchEquipmentModelsDictionaryRequest } from '../../core/openapi/bff-admin-api';
import { FormControl } from '@angular/forms';

export enum FirmwareAction {
  Create,
  Edit,
}

export interface IFirmwareItem {
  id: string;
  name: string;
  version: string;
  comment?: string;
  equipmentModels: IEquipmentModel[];
  createdBy: string;
  createdByName: string;
  createdDate: string;
  originFileName: string;
}

export interface IEquipmentModel {
  id: string;
  name: string;
}

export interface IFirmwareModalData {
  title: string;
  action: FirmwareAction;
  firmwareId?: string;
}

export interface IFirmwareModalPublicData {
  formChanged: boolean;
}

export interface IEquipmentModelSearchRequest
  extends Omit<SearchEquipmentModelsDictionaryRequest, 'includeTotalCount' | 'skip' | 'take'> {
  includeTotalCount: boolean;
  skip: number;
  take: number;
}

export interface IFirmwaresFilterFormGroup {
  search: FormControl<string>;
  models: FormControl<string[]>;
}

export interface IFirmwareFormControls {
  name: FormControl<string>;
  version: FormControl<string>;
  models: FormControl<string[]>;
  comment: FormControl<string>;
  file: FormControl<File[] | null>;
}
